import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';


const initialState = {
    token: null,
    error: null,
    loading: false,
    documents: [],
    document: {}
}

const authStart = (state, action) => {
    return updateObject(state, {
        error: null,
        loading: true
    }); 
}

const create_Start = (state, action) => {
    return updateObject(state, {  
        loading: true
    }); 
} 

const create_Success = (state, action) => {
    return updateObject(state, {
        loading: false
    }); 
} 

const authSuccess = (state, action) => {
    return updateObject(state, {
        token: action.token,
        error: null,
        loading: false
    }); 
} 
  
const authFail = (state, action) => {
    return updateObject(state, {
        error: action.error,
        loading: false
    });
}

const documentsState = (state, action) => {
    return updateObject(state, {
        documents: action.documents 
    });
}


const authLogout = (state, action) => {
    return updateObject(state, {
        token: null
    });
} 
 
const reducer = (state=initialState, action) => {
    switch (action.type) {
        case actionTypes.AUTH_START: return authStart(state, action);
        case actionTypes.CREATE_START: return create_Start(state, action);
        case actionTypes.AUTH_SUCCESS: return authSuccess(state, action);
        case actionTypes.CREATE_SUCCESS: return create_Success(state, action);
        case actionTypes.AUTH_FAIL: return authFail(state, action);
        case actionTypes.AUTH_LOGOUT: return authLogout(state, action);
        case actionTypes.FETCH_DOCUMENTS: return documentsState(state, action);
        
        default:
            return state; 
    }
}
 
export default reducer;